import * as React from 'react';

import i18n from 'helper/i18n';
import appConfig from 'helper/mapBackendConfig';

import UIAsset from 'components/atoms/UIAsset';

export type BadgePropsType = {
	linkClass?: string;
	imageClass?: string;
};

const language = appConfig.env.language || 'de';
const baseLabel = `react.impulsCoach.fragments.storeBadge`;
const label = (store: 'appStore' | 'playStore', tail: string) => i18n(`${baseLabel}.${store}.${tail}`);

const getLanguageBasedBadgeImage = (platform: string): string => {
	const vendor = platform === 'app-store' ? 'apple' : 'google';
	return `img/svg/store/${vendor}/${platform}-badge-${language}.svg`;
};

const BadgeLinkType = {
	appStore: 'appStore',
	playStore: 'playStore',
};

type BadgeLinkPropsType = {
	type: any; // $Values<BadgeLinkType>
	children?: any;
};

const BadgeLink = ({ type, children }: BadgeLinkPropsType) => (
	<a
		className="m-notification__store-link"
		href={label(type, 'link')}
		// alt={label(type, 'alt')} TODO: alt does not exist on interdistinct "a" tag
		// eslint-disable-next-line
		target="_blank"
		rel="noreferrer"
	>
		{children}
	</a>
);

const AppStoreBadge = ({ imageClass, linkClass }: BadgePropsType) => {
	return (
		<React.Fragment>
			<BadgeLink type={BadgeLinkType.appStore}>
				<UIAsset className={imageClass} src={getLanguageBasedBadgeImage('app-store')} />
			</BadgeLink>
		</React.Fragment>
	);
};

const PlayStoreBadge = ({ imageClass, linkClass }: BadgePropsType) => {
	return (
		<React.Fragment>
			<BadgeLink type={BadgeLinkType.playStore}>
				<UIAsset className={imageClass} src={getLanguageBasedBadgeImage('google-play')} />
			</BadgeLink>
		</React.Fragment>
	);
};

export { AppStoreBadge, PlayStoreBadge };
